import React from 'react';
import { Clock, Users, ChevronRight, MessageSquare } from 'lucide-react';
import { StatusBadge, PriorityBadge } from './TaskBadges';
import { stationLabel, serviceLabel } from '../../utils/kitchenTasks';

const TaskRow = ({ task, onOpen }) => {
  const assignees = (task.assigned_user_names || []).join(', ');
  return (
    <button type="button" onClick={() => onOpen(task)}
      className={`w-full text-left bg-white border rounded-2xl px-4 py-3 min-h-[64px] flex items-center gap-3 hover:bg-gray-50 transition-colors ${task.is_late ? 'border-red-300' : 'border-gray-200'}`}
      data-testid={`task-row-${task.id}`}>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <span className="font-semibold text-gray-900 text-sm md:text-base truncate" data-testid={`task-row-title-${task.id}`}>{task.title}</span>
          <PriorityBadge priority={task.priority} />
          <StatusBadge status={task.status} isLate={task.is_late} />
        </div>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-500">
          <span>{stationLabel(task.category_name)}</span>
          <span>· {serviceLabel(task.service)}</span>
          {task.due_time && <span className="inline-flex items-center gap-1"><Clock size={11} />{task.due_time}</span>}
          {task.planned_quantity != null && <span>· {task.planned_quantity} {task.unit}</span>}
          <span className={`inline-flex items-center gap-1 ${assignees ? '' : 'text-gray-400 italic'}`}><Users size={11} />{assignees || 'Non affectée'}</span>
          {task.description && <span className="inline-flex items-center gap-1 truncate max-w-[200px]"><MessageSquare size={11} />{task.description}</span>}
        </div>
      </div>
      <ChevronRight size={18} className="text-gray-400 flex-shrink-0" />
    </button>
  );
};

export default TaskRow;
